export default __webpack_public_path__ + "20cbc4705a2f7fb6255825301671a1a5.png";